<template>
  <div
    :class="['toast_icon', type]"
  >
    <sprite
      class="svg"
      :key="'toast_icon_' + iconProps.name"
      :name="iconProps.name"
      :type="iconProps.type"
      :style="{
        color: iconProps.color
      }"
    />
  </div>
</template>

<script>
import sprite from '$$vueCmp/VueIcon/svgSprite.vue';
import { TYPE } from 'vue-toastification';

export default {
  name: 'ToastIcon',
  components: {
    sprite
  },
  props: {
    type: {
      type: String,
      required: true,
      default: TYPE.INFO,
      validator(value) {
        return [
          TYPE.SUCCESS,
          TYPE.INFO,
          TYPE.WARNING,
          TYPE.ERROR,
          'close'
        ].includes(value);
      }
    }
  },
  computed: {
    iconProps() {
      let props = null;

      switch (this.type) {
        case TYPE.SUCCESS:
          props = {
            name: 'success',
            type: 'bold',
            color: '#00564C'
          };
          break;
        case TYPE.WARNING:
          props = {
            name: 'warning-1',
            type: 'bold',
            color: '#FF9A00'
          };
          break;
        case TYPE.ERROR:
          props = {
            name: 'close-2',
            type: 'bold',
            color: '#DD3636'
          };
          break;
        case 'close':
          props = {
            name: 'close-1',
            type: 'regular',
            color: '#B2B2B2'
          };
          break;
        case TYPE.INFO:
        default:
          props = {
            name: 'info',
            type: 'bold',
            color: '#1565C0'
          };
          break;
      }

      return props;
    }
  },
  emits: ['click']
}
</script>

<style lang="less">
.toast_icon {
  display: flex;
  justify-content: center;
  align-items: center;

  &.close {
    padding-left: 0;
    margin-left: 16px;
    cursor: pointer;
  }

  &:not(.close) {
    margin: 0 16px 0 0;
    width: 24px;
  }
}

.Vue-Toastification__toast {
  padding: 16px;
}
</style>